module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/dog-beach-582.0d57b5b0ddb9e42f.png"+" 582w",
        images: [{path: "https://static.sniffspot.com/packs/img/dog-beach-582.0d57b5b0ddb9e42f.png",width: 582,height: 400}],
        src: "https://static.sniffspot.com/packs/img/dog-beach-582.0d57b5b0ddb9e42f.png",
        toString: function(){return "https://static.sniffspot.com/packs/img/dog-beach-582.0d57b5b0ddb9e42f.png"},
        
        width: 582,
        height: 400
      }